import { render } from "./DraftTreeView.vue?vue&type=template&id=e5b576a8&scoped=true&ts=true"
import script from "./DraftTreeView.vue?vue&type=script&lang=ts"
export * from "./DraftTreeView.vue?vue&type=script&lang=ts"

import "./DraftTreeView.vue?vue&type=style&index=0&id=e5b576a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b576a8"]])

export default __exports__